import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import ScrollToTop from './components/ScrollToTop';
import './App.css';

const About = React.lazy(() => import('./screens/About'));
const Home = React.lazy(() => import('./screens/Home'));
const Privacy = React.lazy(() => import('./screens/Privacy'));
const ThankYou = React.lazy(() => import('./screens/ThankYou'));

function App() {
  return (
    <Suspense fallback={<></>}>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>
      </Router>
    </Suspense>
  );
}

export default App;
